import Data from 'react-k2-api/Api/Data'
import PrimaryKey from 'react-k2-api/Api/PrimaryKey'
import { Type } from 'class-transformer'
import TAttendanceWorkShiftTypeDM from './TAttendanceWorkShiftTypeDM'
import TTextDM from './TTextDM'
import PrCalTypDay from './PrCalTypDay'
import PrCalTypHours from './PrCalTypHours'

/**
 * Kalendář - položky
 */
export default class TCodeCalendarItemVisualDM extends Data {
	public static className = 'TCodeCalendarItemVisualDM'
	public static primaryKey = 'RID'
	public static systemFields = [
		'RecordID',
	]

	public getPrimaryKey(): PrimaryKey {
		return this.RID!
	}

	public static isHeader = true

	/**
	 * Datum směny
	 */
	WorkshiftDate?: Date

	/**
	 * Směna
	 */
	WorkshiftRID?: number

	/**
	 * Interval
	 */
	IntervalRID?: number

	/**
	 * RID definice
	 */
	DefinitionRID?: number

	/**
	 * Číslo
	 */
	RID?: number

	/**
	 * Čas přerušení
	 */
	BreakTIme?: number

	/**
	 * Celkový čas
	 */
	TotalTime?: number

	/**
	 * Datum do
	 */
	DateTo?: Date

	/**
	 * Datum od
	 */
	DateFrom?: Date

	/**
	 * S.hodn.3
	 */
	StringValue3?: string

	/**
	 * S.hodn.2
	 */
	StringValue2?: string

	/**
	 * Č.hodn.L
	 */
	LongValue?: number

	/**
	 * Čas celk.
	 */
	TimeTotal?: number

	/**
	 * Č.hodn.N
	 */
	ShortValue?: number

	/**
	 * Popis
	 */
	Description?: string

	/**
	 * Čas do
	 */
	TimeTo?: number

	/**
	 * Čas od
	 */
	TimeFrom?: number

	/**
	 * Datum
	 */
	Date?: Date

	/**
	 * Kalendář
	 */
	CodeCalendarId?: number

	/**
	 * undefined
	 */
	RecordMod?: number

	/**
	 * undefined
	 */
	RecordES?: number

	/**
	 * Číslo
	 */
	RecordID?: number

	/**
	 * undefined
	 */
	RecordState?: number

	/**
	 * s
	 */
	SelectionImgCalc?: string

	/**
	 * LegislationContext
	 */
	LegislationContextCalc?: number

	/**
	 * Datum
	 */
	CurrentDateCalc?: Date

	/**
	 * Čas
	 */
	CurrentTimeCalc?: Date

	/**
	 * Akceptovat změny v definici
	 */
	AcceptChangeInDefBitCalc?: number

	/**
	 * Čas od
	 */
	TimeFromCalc?: Date

	/**
	 * Čas do
	 */
	TimeToCalc?: Date

	/**
	 * undefined
	 */
	IsAllDayModeCalc?: string

	/**
	 * undefined
	 */
	ItemCaptionCalc?: string

	/**
	 * undefined
	 */
	ItemColorCalc?: number

	/**
	 * undefined
	 */
	ItemVisualPriorityCalc?: number

	/**
	 * undefined
	 */
	SectionDurationInHoursCalc?: number

	/**
	 * undefined
	 */
	BreakDurationInHoursCalc?: number

	/**
	 * undefined
	 */
	HoursCalc?: number

	/**
	 * undefined
	 */
	MinCalc?: number

	/**
	 * undefined
	 */
	TimeCalc?: number

	/**
	 * undefined
	 */
	IntervalDaysCalc?: number

	/**
	 * undefined
	 */
	IntervalHoursCalc?: number

	/**
	 * undefined
	 */
	IntervalMinutesCalc?: number

	/**
	 * undefined
	 */
	IntervalStartDateCalc?: Date

	/**
	 * undefined
	 */
	IntervalEndDateCalc?: Date

	/**
	 * undefined
	 */
	IntervalStartTimeCalc?: Date

	/**
	 * undefined
	 */
	IntervalEndTimeCalc?: Date

	/**
	 * undefined
	 */
	IntervalTimeCalc?: number

	/**
	 * Datum a čas od
	 */
	IntervalStartDateTimeCalc?: Date

	/**
	 * Datum a čas do
	 */
	IntervalEndDateTimeCalc?: Date

	/**
	 * Typ směny modelu pracovní doby
	 */
	@Type(() => TAttendanceWorkShiftTypeDM)
	AttendanceWorkShiftTypeRID?: TAttendanceWorkShiftTypeDM

	/**
	 * Typ směny
	 */
	@Type(() => TTextDM)
	WorkShiftTypeId?: TTextDM

	/**
	 * Typ položky
	 */
	@Type(() => TTextDM)
	ItemTypeId?: TTextDM

	/**
	 * Priorita
	 */
	@Type(() => TTextDM)
	PriorityId?: TTextDM

	/**
	 * Typ dne
	 */
	@Type(() => PrCalTypDay)
	DayTypeId?: PrCalTypDay

	/**
	 * Typ č.ús.
	 */
	@Type(() => PrCalTypHours)
	CalendarRecordTypeId?: PrCalTypHours

	/**
	 * Typ zdroje
	 */
	@Type(() => TTextDM)
	SourceTypeIdCalc?: TTextDM

	/**
	 * Den v týdnu
	 */
	@Type(() => TTextDM)
	DayInWeekCalc?: TTextDM

	/**
	 * undefined
	 */
	@Type(() => TTextDM)
	ItemStateCalc?: TTextDM

	/**
	 * Změna skupiny práv
	 */
	public ChangeGroupRightCOMMAND() {
		return this.executeCommand('ChangeGroupRightCOMMAND')
	}

	/**
	 * Změna skupiny práv
	 */
	public BulkChangeGroupRightCOMMAND() {
		return this.executeCommand('BulkChangeGroupRightCOMMAND')
	}

	/**
	 * Aktualizace počítaných polí
	 */
	public BulkUpdateCalcFieldsCOMMAND() {
		return this.executeCommand('BulkUpdateCalcFieldsCOMMAND')
	}

	/**
	 * Kontrola legislativy
	 */
	public SwitchOffLegislationValidationCOMMAND() {
		return this.executeCommand('SwitchOffLegislationValidationCOMMAND')
	}
}